module.exports = __webpack_public_path__ + "media/images/users_fuerte-0bc08af30c28ab815cd7337acbca489f.svg";